import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const IncidentReport = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default IncidentReport;
